<div *ngIf="show|async" class="clock clockposition_{{position}}" [innerHTML]="(dateTimeString|async)|raw">
</div>
